const config = {
  // BACKEND_URL: 'https://backend.migrator.krtech.dev',
  BACKEND_URL: 'https://backend.cs-migrator.krtech.dev',
  // BACKEND_URL: 'https://3d6064fc450e.ngrok-free.app',
  // BACKEND_URL: 'https://monday-migrator.connect.capabilitysource.com',
  // FRONTEND_URL: 'https://f93aa4e1c484.ngrok-free.app',
  //  FRONTEND_URL: 'https://d2sjjf3ff04yn3.cloudfront.net',
}

export default config

// const config = {
//   BACKEND_URL: 'http://localhost:3001',
//   FRONTEND_URL: 'https://1c34-141-136-183-248.eu.ngrok.io',
// }
